module.exports = __webpack_public_path__ + "img/logo-company.e2ed1578.png";